const icon = "w-5 h-5";

const loading = "text-sm text-muted-foreground mt-2";
const empty = "text-sm text-muted-foreground mt-2";

const errorCard = "bg-destructive/10 border border-destructive/20 rounded-lg p-4 flex items-center gap-3 mt-2";
const errorIcon = "text-destructive";

const tableWrapper = "overflow-x-auto -mx-4 sm:mx-0";
const table = "min-w-full bg-card rounded-lg border border-border shadow-sm mt-4 w-full";
const tr = "border-b border-border last:border-b-0 hover:bg-accent transition-colors";
const th =
  "hidden sm:table-cell px-4 sm:px-6 py-3 text-left text-xs font-semibold uppercase tracking-wider text-muted-foreground bg-muted/50 whitespace-nowrap";

const td = "hidden sm:table-cell px-4 sm:px-6 py-3 text-sm text-foreground whitespace-nowrap";

const timeBadge = "inline-flex items-center gap-1.5 px-2.5 py-1 rounded-full text-xs font-medium bg-info/10 text-info";

const badgeIcon = "w-3.5 h-3.5";

const badgeIconSmall = "h-3 w-3 mr-1";

const mobileGrid = "grid grid-cols-1 sm:hidden gap-3 mt-4";

const mobileCard = "rounded-xl border border-border bg-card p-4 shadow-sm";

const mobileCardRow = "flex items-center justify-between mb-2 last:mb-0";

const mobileCardLabel = "text-xs font-medium text-muted-foreground";

const mobileCardValue = "text-sm text-foreground";

export {
  icon,
  loading,
  empty,
  errorCard,
  errorIcon,
  tableWrapper,
  table,
  tr,
  th,
  td,
  timeBadge,
  badgeIcon,
  badgeIconSmall,
  mobileGrid,
  mobileCard,
  mobileCardRow,
  mobileCardLabel,
  mobileCardValue,
};
